import React from 'react';

const FinancialPlanningChildsMarriageBottomline = () => {
  const benefits = [
    {
      title: "Early Accumulation Strategy",
      description: "Starting a dedicated marriage fund early leverages the power of compounding, allowing smaller contributions to grow significantly over time while reducing financial pressure as the wedding date approaches."
    },
    {
      title: "Inflation-Protected Savings",
      description: "Strategically allocating investments to outpace wedding inflation (which often exceeds general inflation) ensures your savings maintain purchasing power for future ceremony and celebration costs."
    },
    {
      title: "Flexible Funding Framework",
      description: "Establishing a balanced portfolio that combines liquidity for immediate expenses with growth investments for long-term needs creates adaptability for changing preferences and wedding trends."
    },
    {
      title: "Multi-generational Planning",
      description: "Incorporating family contribution strategies and clear financial boundaries helps manage expectations while potentially sharing financial responsibility across generations in a structured manner."
    }
  ];

  return (
    <div className="w-full bg-gradient-to-br from-[#113262] to-[#1C52A0] py-12 px-8">
      <div className="max-w-6xl w-full mx-auto px-4 sm:px-6 lg:px-8 py-4 md:py-6 lg:py-8">
        <div className="text-center mb-16">
          <h2 className="text-white text-2xl md:text-3xl lg:text-4xl font-bold mb-4">
            Bottomline: Benefits of Strategic Marriage Financial Planning
          </h2>
          <div className="w-24 h-1 bg-[#F49611] mx-auto mt-4"></div>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-16">
          {benefits.map((benefit, index) => (
            <div key={index} className="relative">
              {/* Decorative number */}
              <div className="absolute -left-8 top-0 text-6xl font-bold text-[#F49611] opacity-10">
                {index + 1}
              </div>
              
              {/* Content */}
              <div className="relative">
                <div className="flex items-start space-x-4">
                  {/* Vertical line decoration */}
                  <div className="hidden md:block w-1 h-full bg-gradient-to-b from-[#F49611] to-transparent"></div>
                  
                  <div className="flex-1">
                    <h3 className="text-[#F49611] text-xl font-semibold mb-4">
                      {benefit.title}
                    </h3>
                    <p className="text-white/80 text-base leading-relaxed">
                      {benefit.description}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FinancialPlanningChildsMarriageBottomline;